export default __webpack_public_path__ + "static/geLogo300x139-906c987511460deed16e1a14d13da86d.png";